import { Injectable } from '@angular/core';
import { BaseService, UrlParam } from "./classes/BaseService";
import { HttpClient } from "@angular/common/http";
import { Global } from './classes/Global';

@Injectable()
export class TopsellerService extends BaseService{

  apiUrl = "Topseller.php?";

  constructor(protected http: HttpClient) {
    super(http);
  }

  getTopSellersForStartPage(country: string, maxItemCount: number) {
    let url = this.serverUrl + this.apiUrl + this.buildUrlParams(
      new UrlParam("action", "getTopsellerForStartpage"),
      new UrlParam("country", country),
      new UrlParam("maxItemCount", maxItemCount.toString()),
      new UrlParam("origin", "website"),
      new UrlParam("store", [Global.ITUNES, Global.AMAZON, Global.VUDU, Global.GOOGLEPLAY].join(','))
    );

    return this.get(url);
  }

}
